import Interface from 'components/Interface';
import Actions from 'components/Actions';
import Title from 'components/Title';
import Author from 'components/Author';
import Notes from 'components/Notes';
import Board from 'components/Board';
import Clues from 'components/Clues';

const Game = () => {
  return (
    <>
      <Title />
      <Author />
      <Board />
      <Actions />
      <Notes />
      <Clues />
      <Interface />
    </>
  );
}

export default Game;
